const toneMap = {
  Present: "bg-[#F4A300]/12 text-[#C27D00] border-[#F4A300]/20",
  In: "bg-[#F4A300]/12 text-[#C27D00] border-[#F4A300]/20",
  Out: "bg-[#0D1B2A]/8 text-[#0D1B2A] border-[#0D1B2A]/12",
  Absent: "bg-rose-50 text-rose-700 border-rose-200",
  Leave: "bg-[#0D1B2A]/8 text-[#0D1B2A] border-[#0D1B2A]/12",
  "On Leave": "bg-[#0D1B2A]/8 text-[#0D1B2A] border-[#0D1B2A]/12",
  Late: "bg-amber-50 text-amber-700 border-amber-200",
  Pending: "bg-slate-100 text-slate-700 border-slate-200",
  "Half Day": "bg-orange-50 text-orange-700 border-orange-200",
  approved: "bg-[#F4A300]/12 text-[#C27D00] border-[#F4A300]/20",
  rejected: "bg-rose-50 text-rose-700 border-rose-200",
  pending: "bg-slate-100 text-slate-700 border-slate-200",
  canceled: "bg-slate-100 text-slate-700 border-slate-200",
};


export default function StatusBadge({ value, testId }) {
  return (
    <span
      className={`inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold ${toneMap[value] || "bg-slate-100 text-slate-700 border-slate-200"}`}
      data-testid={testId}
    >
      {value}
    </span>
  );
}